import { render, staticRenderFns } from "./dataSourceDetail.vue?vue&type=template&id=c74833f6&"
import script from "./dataSourceDetail.vue?vue&type=script&lang=js&"
export * from "./dataSourceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports